import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SidenavService } from './sidenav.service';


@Injectable({
  providedIn: 'root'
})
export class DinamicLoaderService {
  loadComponent$ = new Subject<{ component: any; data: any }>();
  constructor(private sidenavService: SidenavService) {

  }


}
